import { TextKey } from '@mews-commander/enums';
import { TimeUnit, UnicodeEntity } from '@mews/enums';
import { DateTimePart, DateTimeService, TimeUnitUtils, useLocalizeText, useTimezone } from '@mews/framework';
import { LocalizedUtcTimeUnit, LocalizedUtcTimeUnitFormat } from '@mews-commander/ui';

interface PartialMonthDayRangeProps {
    proRataStartUtc: string;
    proRataEndUtc: string;
    showDaysCount?: boolean;
}
export const PartialMonthDayRange = ({ proRataStartUtc, proRataEndUtc, showDaysCount }: PartialMonthDayRangeProps) => {
    const timezone = useTimezone();
    const startDate = DateTimeService.fromUtcString(proRataStartUtc, timezone);
    const endDate = DateTimeService.fromUtcString(proRataEndUtc, timezone);
    const daysCount = TimeUnitUtils.dateTimeToTimeUnitCount({ timePart: DateTimePart.Day, greedy: true })(
        startDate,
        endDate
    );

    const localizeText = useLocalizeText();
    const selectedDaysLocalized = localizeText({
        textKey: TextKey.SelectedDays,
        substitutes: { count: daysCount },
    });

    return (
        <>
            <LocalizedUtcTimeUnit
                format={LocalizedUtcTimeUnitFormat.Short}
                timeUnit={TimeUnit.Day}
                utcString={proRataStartUtc}
            />
            {UnicodeEntity.NoBreakSpace}
            {UnicodeEntity.Dash}
            {UnicodeEntity.NoBreakSpace}
            <LocalizedUtcTimeUnit
                format={LocalizedUtcTimeUnitFormat.Long}
                timeUnit={TimeUnit.Day}
                utcString={proRataEndUtc}
            />
            {showDaysCount && (
                <>
                    {UnicodeEntity.NoBreakSpace}
                    {UnicodeEntity.LeftParenthesis}
                    {selectedDaysLocalized}
                    {UnicodeEntity.RightParenthesis}
                </>
            )}
        </>
    );
};
